// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
/**
 * Download empty template
 * Download empty template
 */
export function downloadEmptyTemplateRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling downloadEmptyTemplate.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update,
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform
    };
    config.queryKey = requestConfig.queryKey || `DownloadEmptyTemplate-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Download empty template
* Download empty template
*/
export function downloadEmptyTemplate(requestParameters, requestConfig) {
    return downloadEmptyTemplateRaw(requestParameters, requestConfig);
}
